<div class="button-select">
  <div class="button-select__label">
    <ion-label>{{ question.label }}</ion-label>

    <app-help-popup *ngIf="question.helpKey" [key]="question.helpKey"> </app-help-popup>
  </div>

  <ion-radio-group [(value)]="value" name="question.label" mode="ios" (ionChange)="valueChanged($event)">
    <div class="button-select__options" [class.has-error]="question.error">
      @for (opt of question.options; track opt.Value) {
        <a class="button-select__options__option" (click)="select(opt, $event)" (keyup.space)="select(opt, $event)">
          <ion-radio [value]="opt.Value"></ion-radio>
          <ion-label>{{ opt.Label }}</ion-label>
        </a>
      }
    </div>
  </ion-radio-group>

  <input class="offscreen" [(ngModel)]="value" required [name]="question.key" #val="ngModel" tabindex="-999" (cdkAutofill)="autoFilled()" />
</div>
